import { getEntityFullName } from '@/utils/string.js'
/**
 * Returns the full name of a user by concatenating first and last names.
 *
 * @param attributes - Object containing optional first_name and last_name properties
 * @returns The user's full name as a string, or empty string if no names provided
 *
 * @example
 * ```ts
 * getUserFullName({ first_name: 'John', last_name: 'Doe' }) // Returns: 'John Doe'
 * getUserFullName({ first_name: 'John' }) // Returns: 'John'
 * getUserFullName() // Returns: ''
 * ```
 */
export const getUserFullName = (attributes?: {
  first_name?: string
  last_name?: string
}) => getEntityFullName(attributes)
